export const achievementsData = [
  {
    id: 'public-speaking',
    href: '/public-speaking',
    isExternal: false,
    icon: 'M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3 3V5a3 3 0 116 0v6a3 3 0 01-3 3z',
    title: '20 Years of Systems Engineering',
    organization: 'Universidad de Cartagena',
    year: '2026',
    description: 'Joined an alumni panel celebrating the program’s 20th anniversary to discuss how AI is reshaping the software industry and professional roles.',
    ctaText: 'View Event Details'
  },
  {
    id: 'academic-changemaker',
    href: '/academic-changemaker-recognition',
    isExternal: false,
    icon: 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4',
    title: 'Academic Changemaker',
    titleClassName: 'academic-changemaker-title',
    titleContent: (
      <>
        Academic<span className="line-break">Changemaker</span>
      </>
    ),
    organization: 'Universidad de Cartagena',
    year: '2024',
    description: 'Recognized for transformative contributions to the Software Engineering program and industry partnerships.',
    ctaText: 'View Recognition'
  },
  {
    id: 'knowledge-catalyst',
    href: '/guest-speaker-event',
    isExternal: false,
    icon: 'M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253',
    title: 'Knowledge Catalyst',
    organization: 'Entrepreneurial Seminars',
    year: '2023',
    description: 'Empowered 500+ engineering students with practical entrepreneurial knowledge, bridging academia and industry realities.',
    ctaText: 'View Event Details'
  },
  {
    id: 'media-leadership',
    href: 'https://nearshoreamericas.com/us-visa-delays-latams-it-progress/',
    isExternal: true,
    icon: 'M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z',
    title: 'Media & Thought Leadership',
    titleContent: (
      <>
        Media & Thought<span className="line-break">Leadership</span>
      </>
    ),
    titleClassName: 'academic-changemaker-title',
    organization: 'Industry Voice',
    year: '2021',
    description: 'Advocated for Latin American entrepreneurs in global tech conversations through media interviews and podcasts.',
    ctaText: 'News Article'
  },
  {
    id: 'entrepreneurial-strategies',
    href: 'https://drive.google.com/file/d/1xuV7dtGoE1mjF3c18TphBZGjAIdyFFxC/view',
    isExternal: true,
    icon: 'M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z',
    title: 'Entrepreneurial Strategies',
    titleContent: (
      <>
        Entrepreneurial<span className="line-break">Strategies</span>
      </>
    ),
    titleClassName: 'academic-changemaker-title',
    organization: 'Universidad de Cartagena',
    year: '2019',
    description: 'Presented key strategies for enhancing entrepreneurship to 300+ attendees, covering financial management, leveraging opportunities, and building sustainable businesses.',
    ctaText: 'Watch Video'
  },
  {
    id: 'podcast-speaker',
    href: 'https://open.spotify.com/episode/5adETqRRRHMXfiFHGro3V3',
    isExternal: true,
    icon: 'M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3 3V5a3 3 0 116 0v6a3 3 0 01-3 3z',
    title: 'Podcast Guest Speaker',
    titleContent: (
      <>
        Podcast Guest<span className="line-break">Speaker</span>
      </>
    ),
    titleClassName: 'academic-changemaker-title',
    organization: 'AIESEC',
    year: '2019',
    description: 'Featured on the Live The Experience Podcast, sharing unique perspectives and insights on youth leadership and professional development.',
    ctaText: 'Listen to Episode'
  }
];
